import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "contoeconomicorecordgroups",
    defaultRoutePath: "/incomestatements/contoeconomicorecordgroup",
    menuItemScope: "incomestatements",
    menuItemName: "contoeconomicorecordgroups",
    routes: [
        {
            path: "/incomestatements/contoeconomicorecordgroup",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
